export { default } from './IncludeIngredient';
